import { AutoComplete, Form, Mentions, Select } from 'antd'
import { useMemo } from 'react'

export default function AppointmentCancel({ fieldName, parameters }) {
  const available = useMemo(
    () => {
      const props = parameters?.properties
      if (!props) return []
      const arr = Array.isArray(props) ? props : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
      return arr.map(({ name }) => ({ label: name, value: name }))
    },
    [parameters]
  )

  return (
    <>
      <Form.Item
        label="ID do Agendamento"
        name={[fieldName, 'action', 'data', 'agendamento_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
      >
        <Select options={available} placeholder="Selecione um parâmetro" />
      </Form.Item>
      <Form.Item
        label="ID do Motivo"
        name={[fieldName, 'action', 'data', 'motivo_id']}
        rules={[{ required: true, message: 'Obrigatório' }]}
        tooltip="Selecione um parâmetro do trigger OU digite um ID fixo (ex: 5). IDs disponíveis via APPOINTMENT_MOTIVES."
      >
        <AutoComplete
          options={available}
          placeholder="Parâmetro ou ID fixo (ex: 5)"
          filterOption={(input, option) => option.value.includes(input)}
        />
      </Form.Item>
      <Form.Item label="Observações" name={[fieldName, 'action', 'data', 'obs']}>
        <Mentions prefix="$" split="" options={available} placeholder="Ex: Cancelado a pedido de $nome" />
      </Form.Item>
    </>
  )
}
